import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AuthzService from 'garaje/services/authz';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';
import type GlobalRoutingService from 'garaje/services/global-routing';
import { Permission } from 'garaje/utils/ui-permissions';

export default class GlobalVisitorComponent extends Component {
  @service declare globalOverviewAccess: GlobalOverviewAccessService;
  @service declare router: RouterService;
  @service declare globalRouting: GlobalRoutingService;
  @service declare authz: AuthzService;

  get visitorsRoute(): string | null {
    return this.globalOverviewAccess.firstAccessibleRouteForGlobalVisitor();
  }

  get isInviteLogActive(): boolean {
    return this.globalRouting.isNestedGlobalRoute() || this.router.isActive('location-overview.invite-log');
  }

  get canVisitApprovals(): boolean {
    return this.authz.hasAnyPermissionAtCurrentCompany([
      Permission.VISITORS_INVITE_VISUAL_COMPLIANCE_APPROVAL_REVIEW,
      Permission.VISITORS_ENTRY_VISUAL_COMPLIANCE_APPROVAL_REVIEW,
      Permission.VISITORS_INVITE_BLOCKLIST_APPROVAL_REVIEW,
      Permission.VISITORS_ENTRY_BLOCKLIST_APPROVAL_REVIEW,
      Permission.VISITORS_INVITE_APPROVAL_REQUIRED_REVIEW,
      Permission.VISITORS_INVITE_AVA_APPROVAL_REVIEW,
      Permission.VISITORS_ENTRY_AVA_APPROVAL_REVIEW,
    ]);
  }
}
